import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { ApiService } from 'src/app/service/api.service';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { ToastService } from 'src/app/service/toast.service';
import { UtilService } from 'src/app/service/util.service';
import { VehicleService } from 'src/app/service/vehicle.service';
import { MessageConstants } from '../../constants/message-constants';
import { Constants } from '../../constants/constants';
import { isNullOrUndefined } from 'util';
import { Router } from '@angular/router';
import { SearchDataService } from 'src/app/service/search-data.service';

@Component({
  selector: 'app-vehicle-list-template',
  templateUrl: './vehicle-list-template.component.html',
  styleUrls: ['./vehicle-list-template.component.scss']
})
export class VehicleListTemplateComponent implements OnInit, OnChanges {

  @Input()
  vehicleList: Array<any>;

  selectedVehicle: any;
  isViewVehicleDetail: boolean = false;

  @Output() selectedVehicleEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedVehicleCloseEmitter: EventEmitter<any> = new EventEmitter<any>();
  selectedVehicles: Array<any> = [];
  reviewVehicleModalMessages = {
    header: "Delete Vehicle(s)",
    message: "Confirm deleting vehicles?",
    note: "Once defleeted, data on these VINs are remotely wiped and VINs would no longer be part of the fleet, and cannot be automatically added back to the account."
  }
  
  constructor(private apiService: ApiService, public authService: AuthenticationService, public utilService: UtilService, private toastService: ToastService, private vehicleService: VehicleService, private router: Router, private searchService: SearchDataService) {

  }

  ngOnInit() {
    if (this.vehicleList && this.vehicleList.length > 0)
      this.vehicleListMasterData = this.vehicleList.map(x => Object.assign({}, x));
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.searchVin = null;
    if (this.vehicleList && this.vehicleList.length > 0)
      this.vehicleListMasterData = this.vehicleList.map(x => Object.assign({}, x));
  }

  vehicleSelected(vehicle) {
    console.log("selected vehicle::", vehicle);
    this.selectedVehicle = JSON.parse(JSON.stringify(vehicle));
    this.selectedVehicle.logo = this.getVehicleLogo(vehicle);
    this.isViewVehicleDetail = true;
    var payload = {
      "key": "VEHICLE",
      "navText": vehicle.vin
    }
    this.selectedVehicleEmitter.emit(payload);
  }

  closeVehicleDetailClicked(event) {
    this.isViewVehicleDetail = false;
    this.selectedVehicleCloseEmitter.emit(true);
  }

  getVehicleLogo(vehicle): string {
    return this.vehicleService.getVehicleLogo(vehicle);
  }

  /**
   * START: Changes for VIN Search
   */  
  vehicleListMasterData: Array<any> = [];
  searchVin: string;

  searchVehicle = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => this.initVehicleList(term))
    )

  initVehicleList(term) {
    console.log("term: ", term);
    if (term === '') {
      this.vehicleList = this.vehicleListMasterData;
    } else if (term.length > 2) {
      return this.vehicleListMasterData.filter(vehicle => vehicle.vin.toLowerCase().indexOf(term.toLowerCase()) > -1);
    }
    return [];
  }

  formatter = (x: { vin: string }) => x.vin;

  onVehicleSelected(event) {
    event.preventDefault();
    // console.log("selected vehicle: ", event.item);
    this.vehicleList = [event.item];
    this.searchVin = event.item;
  }
  /**
   * END: Changes for VIN Search
   */ 

  onDeleteVehicles() {
    console.log("selected vehicles::", this.selectedVehicles);
    document.getElementById("openReviewVehicles").click();
  }

  resetSelectedVehicles() {
    this.selectedVehicles = [];
    this.resetCheckbox();
  }

  resetCheckbox() {
    var items = document.getElementsByName('checkbox');
    for (var i = 0; i < items.length; i++) {
      if (items[i]["type"] == 'checkbox')
        items[i]["checked"] = false;
    }
  }

  reviewVehiclesSubmit(vehicles) {
    this.selectedVehicles = vehicles;
    this.defleetVehicles();
  }

  isVehicleSelected(vehicle: string): boolean {
    if (isNullOrUndefined(this.selectedVehicles) || this.selectedVehicles.length == 0) return false;
    return this.selectedVehicles.some(v => v.vin === vehicle);
  }

  onVehicleSelectionChange(checked: boolean, vehicle: any) {
    var vehicleIndex = this.selectedVehicles.findIndex(v => v.vin === vehicle.vin);

    if (checked && vehicleIndex == -1) {
      this.selectedVehicles.push(vehicle);
    } else if (!checked && vehicleIndex >= 0) {
      this.selectedVehicles.splice(vehicleIndex, 1);
    }
  }

  getDefleetVehiclesPayload() {
    let vehicles = this.selectedVehicles.map((vehicle) => vehicle.vin);
    return {
      "vehicles": vehicles
    }
  }

  defleetVehicles() {
    var requestPayload = this.getDefleetVehiclesPayload();

    // document.getElementById("closeReviewVehicles").click();
    // this.resetSelectedVehicles();
    // console.log("Delete request: ", requestPayload);
    // this.searchService.searchForData(requestPayload.vehicles[0]);
    
    this.utilService.showSpinner();
    this.apiService.defleetVehicles(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      console.log("Defleet vehicle(s) initiated: ", data);
      this.toastService.showSuccess(MessageConstants.DEFLEET_VEHICLES_INITIATED);
      document.getElementById("closeReviewVehicles").click();
      this.resetSelectedVehicles();
      // this.searchService.searchForData(requestPayload.vehicles[0]);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.defleetVehicles();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getVehicleEnrollmentStatus(vehicle: any): string {
    return this.utilService.getVehicleEnrollmentStatus(vehicle);
  }
}
